module.exports = __webpack_public_path__ + "static/media/screenshot5.9be25417.png";